var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTimelinePaid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "App",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Profile-detail",
    transform: "translate(-681.000000, -598.000000)",
    fill: "#2EC4B6",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-timeline-paid",
    transform: "translate(681.000000, 598.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.24,9.84 C10.24,11.68 8.72,11.92 8.4,12 L8.4,13.04 L7.6,13.04 L7.6,12 C7.36,12 5.68,11.76 5.68,9.44 L7.2,9.44 C7.2,10.8 7.92,10.72 8,10.72 C8.08,10.72 8.72,10.72 8.72,9.84 C8.72,8.08 5.92,8.88 5.92,6.16 C5.92,4.32 7.44,4.08 7.68,4 L7.68,2.88 L8.48,2.88 L8.48,4.08 C8.72,4.16 10.16,4.48 10.16,6.56 L8.64,6.56 C8.64,5.44 8.16,5.28 8,5.28 C7.92,5.28 7.36,5.28 7.36,6.24 C7.52,7.76 10.24,7.28 10.24,9.84 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,16 C3.6,16 0,12.4 0,8 L1.6,8 C1.6,11.52 4.48,14.4 8,14.4 C9.92,14.4 11.76,13.52 12.96,12 L14.24,13.04 C12.72,14.88 10.4,16 8,16 Z M16,8 L14.4,8 C14.4,4.48 11.52,1.6 8,1.6 C6.08,1.6 4.24,2.48 3.04,4 L1.76,2.96 C3.28,1.12 5.6,0 8,0 C12.4,0 16,3.6 16,8 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0.8 0.8 0.8 4.8 4.8 4.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "15.2 15.2 15.2 11.2 11.2 11.2"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTimelinePaid);
export default __webpack_public_path__ + "static/media/icon-timeline-paid.378935762474c2349ffd6a82415ca915.svg";
export { ForwardRef as ReactComponent };